import { getTranliteratedSlug } from "./tranliterate";

export function getProductDetailUrl(name: string, id: string | number, onlySlug: boolean = false): string {
  return (onlySlug ? '' : '/item/') + getTranliteratedSlug(name).replaceAll('/', ' ').replaceAll(',', ' ').replaceAll('.', '').trim().split(/[\s,\t,\n]+/).join('-') + '-' + id;
}

